import { axios } from '@Root/API'

export const getFieldMappings = id => {
  return axios.get(`cognito-form-field-mappings`, { params: { cognito_form_id: id } })
}
